import { useEffect } from 'react';

export const useSecuredPaywallLock = (isLocked) => {
	useEffect(() => {
		const previousOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';

		if (!isLocked) {
			return () => {
				document.body.style.overflow = previousOverflow;
			};
		}

		const blockEscape = (event) => {
			if (event.key === 'Escape') {
				event.preventDefault();
				event.stopImmediatePropagation();
			}
		};

		document.addEventListener('keydown', blockEscape, { capture: true });

		return () => {
			document.body.style.overflow = previousOverflow;
			document.removeEventListener('keydown', blockEscape, { capture: true });
		};
	}, [isLocked]);
};
